import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    branch: null,
    service: null,
    date: null,
    queue: null,
    phone: null
  },
  getters: {
    getBranch: state => {
      return state.branch
    },
    getService: state => {
      return state.service
    },
    getDate: state => {
      return state.date
    },
    getQueue: state => {
      return state.queue
    },
    getPhone: state => {
      return state.phone
    }
  },
  mutations: {
    setBranch (state, branch) {
      state.branch = branch;
    },
    setService (state, service) {
      state.service = service;
    },
    setDate (state, date) {
      state.date = date;
    },
    setQueue (state, queue) {
      state.queue = queue;
    },
    setPhone (state, phone) {
      state.phone = phone;
    }
  },
  actions: {
    setBranch (context, branch) {
      context.commit('setBranch', branch)
    },
    setService (context, service) {
      context.commit('setService', service)
    },
    setDate (context, date) {
      context.commit('setDate', date)
    },
    setQueue (context, queue) {
      context.commit('setQueue', queue)
    },
    setPhone (context, phone) {
      context.commit('setPhone', phone)
    }
  }
})
